import MComponent from '../../Toolkit/Components/Component';
import React, {ReactElement} from 'react';
import {WithMsalProps} from '@azure/msal-react';
import {ListBox} from 'primereact/listbox';

export type ReportData = {
    name: string;
    embedUrl: string;
    reportId: string;
}

type Props = WithMsalProps & {
    itemTemplate?: (data: ReportData) => ReactElement;
    itemSelected?: (data: ReportData) => void;
    data: ReportData[];
    className?: string;
}

type State = {
}

class PowerBiList extends MComponent<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.initializeState();
    }

    public bindMethods(): void {
    }

    private initializeState(): void {
        this.state = {
            data: []
        }
    }

    private itemSelected(selectedName: ReportData): void {
        const selectedData = this.props.data.filter(d => d.name === selectedName.name);

        if(this.props.itemSelected !== undefined) {
            this.props.itemSelected(selectedData[0]);
        }
    }

    private itemTemplate(option: ReportData): ReactElement {
        return <React.Fragment>
            <div>{option.name}</div>
            <div>{option.reportId}</div>
        </React.Fragment>
    }

    public render(): ReactElement {
        const optionTemplate = (this.props.itemTemplate !== undefined)
                               ? this.props.itemTemplate
                               : this.itemTemplate

        return <ListBox options={this.props.data}
                        optionLabel='name'
                        onChange={(e) => this.itemSelected(e.value)}
                        itemTemplate={optionTemplate}
                        className={this.props.className}
        />;
    }
}

export default PowerBiList